"use client"

import styled from "@emotion/styled"
import { useTranslations } from "next-intl"
import FormHelperErrorIcon from "../ui/icons/FormHelperErrorIcon"
import FormHelperValidIcon from "../ui/icons/FormHelperValidIcon"

const StyledContainer = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
`

type Props = {
  render: boolean
  error: boolean
  text?: string
  locale?: string
}

function CustomHelperText({ render, error, text }: Props) {
  if (!render) return null
  const t = useTranslations("InnerPages")
  return (
    <StyledContainer>
      {error ? <FormHelperErrorIcon /> : <FormHelperValidIcon />}
      <p
        style={{
          margin: 0,
          color: error ? "#C92418" : "#008015",
          marginRight: "4px",
          fontSize: "12px",
        }}
      >
        {text || t("completed")}
      </p>
    </StyledContainer>
  )
}

export default CustomHelperText
